import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RecipientOtpApiService } from '../../shared/services/auth/recipient-otp-api.service';
import { AuthStateService } from './auth-state.service';

export const publicOnlyGuard: CanActivateFn = (_, state) => {
    const recipientOtpApiService = inject(RecipientOtpApiService);
    const authStateService = inject(AuthStateService);

    return recipientOtpApiService.checkAuth().pipe(
        tap(() => {
            authStateService.setOnProtectedRoute(false);
        }),
        catchError(() => {
            authStateService.setOnProtectedRoute(false);
            return of(false);
        }),
        map((isAuthenticated) => {
            return !isAuthenticated;
        })
    );
};
